import React, { lazy, Suspense } from 'react';
import Header from "../Components/Header"
import Footer from '../Components/Footer';
import * as routes from '../Configs/routes';
import HomePage from './Home/HomePage';
import Loader from './MicroComponents/Loader';
import { APP_NAME, APP_TAGLINE } from '../Configs/appConfig';
import { Helmet } from 'react-helmet';
const TournamentView = lazy(()=> import('./Admin/TournamentView'))
const RegistrationView = lazy(()=> import('./Registration/RegistrationView'));
const Stats = lazy(()=> import('./Stats/Stats'));
const Privacy = lazy(()=> import('./Others/Privacy'));
const PublicTournaments = lazy(()=> import('./PublicTournaments/PublicTournaments'));
const TournamentPage = lazy(()=> import('./PublicTournaments/TournamentPage'));
const ManageAdmins = lazy(()=> import('./Admin/ManageAdmins'));
const Dashboard =  lazy(()=> import('./Admin/Dashboard'));
export const pages = [{
    displayName: 'Home',
    path: routes.HOME,
    exact: true,
    component: () => (
        <>
            <Header/>
            <Helmet>
                <title>{APP_NAME} | {APP_TAGLINE}</title>
            </Helmet>
            <HomePage/>
            <Footer/>
        </>
    )
},{
    displayName: 'Tournaments',
    path: routes.TOURNAMENTS,
    exact: true,
    component: () => (
        <>
            <Header/>
                <Helmet>
                    <title>Tournaments | {APP_NAME}</title>
                </Helmet>
                <Suspense fallback={<Loader/>}>
                    <PublicTournaments/>
                </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Privacy Policy',
    path: routes.PRIVACY,
    exact: true,
    component: ({match}) => (
        <>
            <Header/>
            <Helmet>
                <title>Privacy | {APP_NAME}</title>
            </Helmet>
            <Suspense fallback={<Loader/>}>
                <Privacy/>
            </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Admin Panel',
    path: routes.ADMIN,
    exact: true,
    component: () => (
        <>
            <Header/>
            <Helmet>
                <title>Dashboard | {APP_NAME}</title>
            </Helmet>
            <Suspense fallback={<Loader/>}>
                <Dashboard/>
            </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Tournament',
    path: routes.TOURNAMENT_VIEW+'/:id',
    exact: false,
    component: ({match}) => (
        <>
            <Header/>
                <Suspense fallback={<Loader/>}>
                    <TournamentView id={match.params.id}/>
                </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Registration Form',
    path: routes.REGISTER+'/:id',
    exact: false,
    component: ({match}) => (
        <>
            <Header/>
            <Suspense fallback={<Loader/>}>
                <RegistrationView id={match.params.id}/>
            </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Stats Page',
    path: routes.STATS+'/:id',
    exact: false,
    component: ({match}) => (
        <>
            <Header/>
            <Suspense fallback={<Loader/>}>
                <Stats id={match.params.id}/>
            </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Tournament Page',
    path: routes.TOURNAMENTS+'/:id',
    exact: false,
    component: ({match}) => (
        <>
            <Header/>
                <Suspense fallback={<Loader/>}>
                    <TournamentPage id={match.params.id}/>
                </Suspense>
            <Footer/>
        </>
    )
},{
    displayName: 'Manage Admins',
    path: routes.MANAGE_ADMINS,
    exact: false,
    component: ({match}) => (
        <>
            <Header/>
                <Helmet>
                    <title>Manage Admins | {APP_NAME}</title>
                </Helmet>
                <Suspense fallback={<Loader/>}>
                    <ManageAdmins/>
                </Suspense>
            <Footer/>
        </>
    )
}]